<template>
  <div class="v-grid">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.v-grid {
  position: relative;
  display: block;
}
</style>
